import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, Link, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Analysis from './pages/Analysis';
import Replays from './pages/Replays';
import Legal from './pages/Legal';
import './styles/app.css';

const NAV = [
  { to: '/', label: 'Analysis', end: true },
  { to: '/replays', label: 'Replays' },
];

const FOOT = [
  { href: 'https://github.com/Ojee02/pitvisor', label: 'GitHub' },
  { href: 'https://discord.com/oauth2/authorize?client_id=892359806898303036&permissions=534723947584&scope=bot', label: 'Add to Discord' },
  { href: 'https://discord.com/invite/uXY5Va4Jbb', label: 'Support server' },
  { href: '/tos', label: 'Terms' },
  { href: '/priv', label: 'Privacy' },
  { href: 'https://github.com/sponsors/0J33', label: 'Sponsor' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="meta">pitvisor — F1 data, no account, no ads</span>
        <nav className="footer-links" aria-label="Footer">
          {FOOT.map((l) => (
            l.href.startsWith('/')
              ? <Link key={l.label} to={l.href}>{l.label}</Link>
              : <a key={l.label} href={l.href} target="_blank" rel="noreferrer">{l.label}</a>
          ))}
        </nav>
        <a className="footer-ojee" href="https://ojee.net" target="_blank" rel="noreferrer">ojee.net</a>
      </div>
    </footer>
  );
}

function Shell({ children, title, description }) {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
      </Helmet>

      <a className="skip" href="#main">Skip to content</a>

      <header className="nav">
        <div className="nav-brand">
          <Link to="/" className="nav-wordmark">pitvisor</Link>
          <span className="nav-divider" aria-hidden="true" />
          <a href="https://ojee.net" target="_blank" rel="noreferrer"
             className="nav-wordmark nav-wordmark--ojee">ojee.net</a>
        </div>
        <nav className="nav-links" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className="nav-link">{n.label}</NavLink>
          ))}
          <a className="nav-link" href="https://github.com/Ojee02/pitvisor" target="_blank" rel="noreferrer">GitHub</a>
        </nav>
      </header>

      <main id="main" className="wrap">{children}</main>

      <Footer />

      <nav className="tabbar" aria-label="Primary">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} className="tabitem">{n.label}</NavLink>
        ))}
      </nav>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <div className="app-root">
        <Routes>
          <Route path="/" element={
            <Shell title="pitvisor · F1 analysis"
                   description="Formula 1 data as interactive graphs: race stats, driver performance, historical comparisons and session replays.">
              <Analysis />
            </Shell>
          } />
          <Route path="/replays" element={
            <Shell title="pitvisor · Replays"
                   description="Replay any recorded F1 session — track map, live timing, race control and telemetry, at your own speed.">
              <Replays />
            </Shell>
          } />
          <Route path="/live" element={<Navigate to="/replays" replace />} />
          <Route path="/tos" element={
            <Shell title="pitvisor · Terms">
              <Legal kind="tos" />
            </Shell>
          } />
          <Route path="/priv" element={
            <Shell title="pitvisor · Privacy">
              <Legal kind="priv" />
            </Shell>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}
